//--------CHANGES FOR "SENDING SMS" IS BEING DONE BY JHILIK and SOUMYA,PLZ DON'T REVERT THE CHANGES----------------//


import React, { useState, useContext } from 'react'
import { Helmet } from 'react-helmet-async'
import { Link as RouterLink, useParams, useNavigate } from 'react-router-dom';
// @mui
import { Box, Button, Card, CardContent, Container, Dialog, DialogActions, DialogContent, Divider, Fab, FormControl, Grid, IconButton, InputLabel, List, ListItem, MenuItem, Select, Stack, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material'
import { KeyboardArrowLeftRounded, Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material'
// components
import Scrollbar from '../../common/common-sidebar/components/scrollbar';
// sections
import { WorklogListRow } from '../../common/common-sidebar/components/sections/@dashboard/requests';
import { acceptFileTypes } from '../../common/common-sidebar/utils/getFileType';
import { useEffect } from 'react';

import { Fragment } from 'react';
import { BaseURL, FEEDBACK_SMS_URL, authKey } from '../../common/URLs';
import Context from '../../common/context/Abrplcontext';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { toast } from 'react-toastify';
import Download from '@mui/icons-material/Download';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { FILE_NAME_VALIDATION_ERROR, HELPDESK_ROLES } from '../../common/constants';
import Badge from 'react-bootstrap/Badge';
import { VALIDATION, capitalizeFunction, fileNameValidation } from '../../common/commonValidations';
import { useTranslation } from 'react-i18next';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { loaderService } from '../../common/custom-loader/loader-service';
import { EditIcon, SaveIcon } from '../../common/icons';
import apiClient from '../../axios';

// const auth = "Bearer "+getLocalStorageItem('id_token')
const GrievanceResolution = (props) => {

  //Fetching ticket list from Context component
  //const {data,getTicketListfunc} = useContext(Context);
  const isUpdatingRef = React.useRef(false);
  const { t } = useTranslation();
  const { ticketlist } = useContext(Context);
  const [data, getTicketListfunc] = ticketlist;
  const [isApiCalled, setIsApiCalled] = useState(false);
  const { ticketNumber } = useParams();
  const [getTicket, setGetTicket] = useState([]);
  const [Documentcheck, setDocumentcheck] = useState(false);
  const [getTktDetail, setGetTicketDetails] = useState([ticketNumber]);
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState({

    fileUploadError: ""

  }
  )
  const [selectedFiles, setSelectedFiles] = useState([]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [requesttype, SetRequesttype] = useState([]);
  const [statusType, SetStatustype] = useState([]);
  const [isSubCatSelected, setIsSubCatSelected] = useState(false);
  const [respData, setRespData] = useState([]);
  const [getCategory, setCategory] = useState("");
  const [getSubCat, setSubCatName] = useState("")
  const [isSubDisbaled, setSubDisabled] = useState(true);

  const [selectedPriority, setSelectedPriority] = useState('');
  const [selectedCat, setSelectedCat] = useState('');
  const [selectedReqType, setSelectedReqType] = useState('');
  const [selectedSubCat, setSelectedSubCat] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [selectedSLA, setSelectedSLA] = useState('');
  const [comment, setComment] = useState([])
  const [addComment, setAddComment] = useState('')
  const [submitCommentForm, setCommentForm] = useState([])
  const [submitForm, setsubmitForm] = useState([])
  const [statusflag, setStatusflag] = useState(false);
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - comment.length) : 0;
  const [Checkuser, setCheckuser] = useState('');
  const [requesterID, serRequesterID] = useState("");
  const [requesterContactNo, setRequesterContactNo] = useState("");
  const [characterLimit] = useState(200);
  const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
  const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
  const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const handleLogModalClose = () => {
    setAddComment('');
    setLogModalOpen(false);
  }
  const [docedit, setDocedit] = useState(false);
  const [isEdit, setEditable] = useState(false);
  function handleEdit() {
    setDocedit(true)
    if (Checkuser != HELPDESK_ROLES?.StakeHolder)
      setEditable(true);
  }
  // const onConfirmSave = () => {
  //   handleConfirmLogModalClose()
  //   setEditable(false);
  //   onSubmit();
  // }

  const onConfirmSave = async () => {
    if (isApiCalled) return;
    setIsApiCalled(true);
    setEditable(false);
    try {
      await onSubmit();
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } catch (error) {
      console.error("API failed:", error);
    } finally {
      setLogConfirmModalOpen(false);
      setIsApiCalled(false);
    }
  };

  const [setTicketNumber] = useState('');
  const getTicketPrefix = () => {
    // Check if the ticket number starts with 'EXT'
    return ticketNumber && ticketNumber.startsWith('EXT') ? 'EXT' : '';
  };

  function handleSave() {
    handleConfirmLogModalOpen();
  }

  function getTicketDetails(ticketNumber) {
    let inputs = ticketNumber;
    loaderService.showLoader();
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/getTicketDetails", inputs,
      {
        headers: {
          "Authorization": "Bearer " + getLocalStorageItem('id_token'),
          "Content-Type": "text/plain"
        },
      }
    ).then((response) => {
      setGetTicketDetails(response.data);
      setSelectedPriority(response.data?.helpdeskGrievanceEnquiryEntity?.[0]?.priority);
      setSelectedCat(response.data?.helpdeskGrievanceEnquiryEntity?.[0]?.grievanceCategory);
      setSelectedReqType(response.data?.helpdeskGrievanceEnquiryEntity?.[0]?.requestType);
      setSelectedSubCat(response.data?.helpdeskGrievanceEnquiryEntity?.[0]?.grievanceSubCategory);
      setSelectedStatus(response.data?.helpdeskGrievanceEnquiryEntity?.[0]?.status);
      setSelectedSLA(response.data?.helpdeskGrievanceEnquiryEntity?.[0]?.sla);
      setComment(response.data?.helpdeskTicketAssignment);
      setSelectedFiles(response.data.helpdeskDocumentMasterEntity)
      serRequesterID(response.data?.helpdeskGrievanceEnquiryEntity?.[0]?.requesterId);
      setRequesterContactNo(response.data?.helpdeskGrievanceEnquiryEntity?.[0]?.requesterContactNo);
      // console.log(selectedCat, 'hi Details');
      loaderService.hideLoader();
    }
    ).catch((error) => {
      console.log(error);
      loaderService.hideLoader();
    })
  }


  // *************Get Value List API*******************
  const fetchRequest = () => {
    loaderService.showLoader();
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/getValueList",
      {
        "serviceType": localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser ? "External" : "Helpdesk",
        "appKey": "Request_Type"
      },
      {
        headers: {

          "Authorization": "Bearer " + getLocalStorageItem('id_token')
        },
      }
    ).then((response) => {
      // console.log(response.data, "hello");
      SetRequesttype(response.data)
      loaderService.hideLoader();
      // setTimeout(() => {
      //   setLoading(false)
      // }, 2500);
      //setLoading(false)
    }).catch((error) => {
      console.log(error);
      loaderService.hideLoader();
    })

  }

  //fetchCategoryAndSubcategory API
  const fetchCatagory = () => {
    loaderService.showLoader();
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/fetchCategoryAndSubcategory",
      {},
      {
        headers: {
          "Authorization": "Bearer " + getLocalStorageItem('id_token'),
          "extFlag": (localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser || getTicketPrefix() === 'EXT') ? true : false
        },
      }
    ).then((response) => {
      // console.log("Success - ", response);
      setRespData(response.data);
      loaderService.hideLoader();
    }).catch((error) => {
      console.log("Error - " + error);
      loaderService.hideLoader();
    })
  }

  useEffect(() => {
    loaderService.showLoader();
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/getUserDetails",
      {},
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem('id_token')
        }
      }
    ).then((response) => {
      setCheckuser(response.data?.usertype);
      loaderService.hideLoader();
    }).
      catch((error) => {
        console.log("error-- ", error);
        loaderService.hideLoader();
      })
  }, [])




  // FETCH STATUS API
  const fetchStatusRequest = () => {
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/getValueList",
      {
        "serviceType": localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser ? "External" : "Helpdesk",
        "appKey": "Status"
      },
      {
        headers: {
          "Authorization": "Bearer " + getLocalStorageItem('id_token')
        },
      }
    ).then((response) => {
      // console.log(response.data, "hello");
      SetStatustype(response.data)
      // console.log(response.data, "status");

    }).catch((error) => {
      console.log(error);
    })

  }

  // API CALL ON UPDATE COMMENT
  // const updateWorklog = () => {

  //   var regex = /[-’/`~!#*$@_%+=^&(){}[\]|;:”<>?\\]/g;

  //   setLogModalOpen(false);
  //   // if (regex.test(addComment)) {
  //   //   toast.error('please do not use any special chreacter')
  //   // }
  //   if (addComment.length > 200) {
  //     toast.error('please enter the question within 200 words')
  //   }

  //   else {

  //     let submitForm = {
  //       "id": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.id,
  //       "ticketNumber": ticketNumber,
  //       "assignedTo": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.assignedto,
  //       "category": selectedCat,
  //       "subCategory": selectedSubCat,
  //       // "dueDate": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.dueDate,
  //       // "crtdOn": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.crtdOn,
  //       "requestType": selectedReqType,
  //       "status": (Checkuser == HELPDESK_ROLES?.StakeHolder && selectedStatus == 'Awaiting End User Response') ? 'Open' : selectedStatus,
  //       "worklogComment": addComment,
  //     }
  //     if (addComment == "" || addComment == null) {
  //       toast.error("Please fill the Worklog Field!")
  //     } else {
  //       apiClient.post(
  //         BaseURL + "/grievanceandhelpdesk/v1/helpdesk/updateWorklog",
  //         submitForm,
  //         {
  //           headers: {
  //             "Authorization": "Bearer " + getLocalStorageItem('id_token')
  //           },
  //         }).then((response) => {
  //           setAddComment('');
  //           setCommentForm(response.data)
  //           getTicketDetails(ticketNumber)
  //           toast.success("Comment Added!")
  //         }).catch((error) => {
  //           console.log(error);
  //         })
  //     }
  //   }
  // }

  const updateWorklog = async () => {
    // block double/rapid clicks
    if (isUpdatingRef.current) return;
    isUpdatingRef.current = true;

    try {
      const regex = /[-’/`~!#*$@_%+=^&(){}[\]|;:”<>?\\]/g;

      setLogModalOpen(false);

      const comment = (addComment ?? "").trim();

      // validations (keep your existing logic)
      if (comment.length > 200) {
        toast.error("please enter the question within 200 words");
        isUpdatingRef.current = false;
        return;
      }

      // if you want to reject special characters, uncomment:
      // if (regex.test(comment)) {
      //   toast.error("please do not use any special chreacter");
      //   isUpdatingRef.current = false;
      //   return;
      // }

      if (!comment) {
        toast.error("Please fill the Worklog Field!");
        isUpdatingRef.current = false;
        return;
      }

      const submitForm = {
        id: getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.id,
        ticketNumber: ticketNumber,
        assignedTo: getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.assignedto,
        category: selectedCat,
        subCategory: selectedSubCat,
        requestType: selectedReqType,
        status:
          (Checkuser === HELPDESK_ROLES?.StakeHolder &&
            selectedStatus === "Awaiting End User Response")
            ? "Open"
            : selectedStatus,
        worklogComment: comment,
      };

      // (optional) show a loader if you have one
      // loaderService?.showLoader?.();

      const response = await apiClient.post(
        BaseURL + "/grievanceandhelpdesk/v1/helpdesk/updateWorklog",
        submitForm,
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        }
      );

      setAddComment("");
      setCommentForm(response?.data);
      await (getTicketDetails?.(ticketNumber) ?? Promise.resolve());
      toast.success("Comment Added!");
    } catch (error) {
      console.log(error);
      const msg =
        error?.response?.data?.description ||
        error?.response?.description ||
        error?.message ||
        "Something went wrong";
      toast.error(msg);
    } finally {
      // loaderService?.hideLoader?.();
      isUpdatingRef.current = false; // allow next click
    }
  };


  useEffect(() => {
    if (selectedCat && selectedSubCat) {
      loaderService.showLoader();
      apiClient.post(
        BaseURL + "/grievanceandhelpdesk/v1/helpdesk/updateTicketPriority",
        {
          "id": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.id,
          "ticketNumber": ticketNumber,
          "assignedTo": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.assignedto,
          "category": selectedCat,
          "subCategory": selectedSubCat,
          // "dueDate": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.dueDate,
          // "crtdOn": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.crtdOn,
          "requestType": selectedReqType,
          "status": selectedStatus,
          "worklogComment": addComment,
          "extFlag": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.extFlag
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem('id_token'),
          }
        }
      ).then((response) => {
        // console.log(response.data, 'set priority and sla changes 999');
        if (response.data.slafound === false) {
          toast.error("SLA not found for category" + " " + `${selectedCat}` + " " + "and sub-category" + " " + `${selectedSubCat}`)
        }
        else {
          setSelectedPriority(response.data.sla.slaPriority)
          setSelectedSLA(response.data.sla.slaDuration)
        }
        loaderService.hideLoader();
      }).catch((error) => {
        console.log(error);
        loaderService.hideLoader();
      })

    }
  }, [getCategory, getSubCat, selectedCat, selectedSubCat])


  //FUNCTION FOR FEEDBACK SMS ON TICKET SOLVE
  const sentFeedbackSMS = () => {
    //**************Dynamic value for final****************

    let feedbackurl = "https://apps.abrpl.co.in/f?t=" + `${ticketNumber}` //+"+"+`${rqID}`;
    //receiving 133 characters only
    // console.log("feedbackurl ----  ",feedbackurl);
    // console.log("requesterContactNo  ----   "+getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.mobile);
    apiClient.post(
      FEEDBACK_SMS_URL,
      {
        "stakeholderUrn": requesterID,
        "mobile": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.mobile,        //requesterContactNo,
        "templateName": "RESOLVED FEEDBACK_1",
        "replaceTexts": {
          "TicketNo": ticketNumber,
          "FeedbackLink": feedbackurl
        }
      },
      {
        headers: {
          // Authorization: "Bearer eyJhbGciOiJSUzI1NiIsImtpZCI6Ilg1ZVhrNHh5b2pORnVtMWtsMll0djhkbE5QNC1jNTdkTzZRR1RWQndhTmsiLCJ0eXAiOiJKV1QifQ.eyJ2ZXIiOiIxLjAiLCJpc3MiOiJodHRwczovL2FicnBsZGV2LmIyY2xvZ2luLmNvbS9hMjdiZDI4ZC1lYmJjLTQwMzYtYjViYi0xNjM1NTE4YjQxNmMvdjIuMC8iLCJzdWIiOiI3YjE0NmMyMC0xYmEwLTQ5NWYtODhjMi01NDgyYTEyNGY5YzkiLCJhdWQiOiI1NTRlOWI1Mi00MmFiLTQyNzItOGE2Zi02N2E1NDM3ZDE1Y2YiLCJleHAiOjE2ODYwMzY2ODEsIm5vbmNlIjoiZGVmYXVsdE5vbmNlIiwiaWF0IjoxNjg1OTUwMjgxLCJhdXRoX3RpbWUiOjE2ODU5NTAyODEsIm9pZCI6IjdiMTQ2YzIwLTFiYTAtNDk1Zi04OGMyLTU0ODJhMTI0ZjljOSIsIm5hbWUiOiJ1bmtub3duIiwiZW1haWxzIjpbImFicnBsZGV2QG91dGxvb2suY29tIl0sInRmcCI6IkIyQ18xX2FicnBsc2NtLWFkbWluLXNpZ24taW4iLCJuYmYiOjE2ODU5NTAyODF9.g3gSq7CsDbDpg7X48g8L_aYw7_a6ewh4nNXBbxWaFItS1xyrxGp_CF36iVNslKIfQx267qFBDf1dd1Zel6K66VtScVu2MtA_4VIPfFx-6lH5bGjeuJE830pTNGKs4drawPpqP0SUmzNLHUDo-U_qM3c20futLFGfQ7AABZmALR17VOn2Fy1RTILRr1bD2QHmE-UQAo7oNI4n3lvcJZcEEdfp5V9Sd62Lza5KrTBCpL4TihDGD2yXW7tSRZoWmTVYHSjZkzDGqVGc6WXBjR6Qw59FO7TFNaJHpKqYScDzhGEK5n35oLnCamalDep3QdPr1q_9a9V3iPLkucJcE1HHbw",
          AuthKey: authKey
        }
      }
    ).then((response) => {
      console.log("response - ", response);
    }).catch((error) => {
      console.log("error - ", error);
    });

  }

  // API CALL ON SUBMIT
  const onSubmit = () => {
    //  Statuschange()
    //console.log(selectedStatus, 'rrrrrrrrrrrrrrrrrrrrrrinthe submit');
    let onSaveForm = {
      "helpdeskGrievanceEnquiryEntityPojo": {
        "ticketNumber": ticketNumber,
        "updatedBy": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.updtdBy,
        "urn": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.urn,
        "assignedto": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.assignedto,
        "mobile": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.mobile,
        "firstName": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.firstName,
        "middleName": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.middleName,
        "lastName": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.lastName,
        // "dueDate": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.dueDate,
        // "crtdOn": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.crtdOn,
        "requestType": selectedReqType,
        "category": selectedCat,
        "subCategory": selectedSubCat,
        "status": (Checkuser == HELPDESK_ROLES?.StakeHolder && selectedStatus == 'Awaiting End User Response' && Documentcheck == 'true') ? 'Open' : selectedStatus,
        "priority": selectedPriority,
        "sla": selectedSLA,
        "description": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.grievanceDescription,
        "extFlag": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.extFlag
      },
      helpdeskDocumentMasterEntity:

        selectedFiles

    }
    // console.log('upppppppppppppppppp', JSON.stringify(onSaveForm));
    apiClient.post(
      BaseURL + '/grievanceandhelpdesk/v1/helpdesk/updateTicketsubmit',
      onSaveForm,
      {
        headers: {
          "Authorization": "Bearer " + getLocalStorageItem('id_token')
        },
      }).then((response) => {
        setsubmitForm(response.data);
        toast.success(response.data.description);
        if (selectedStatus === "Resolved" && statusflag == true) {
          sentFeedbackSMS();
        }
        navigate('../requests')
      }).catch((error) => {
        console.log(error);
      })
  }

  // Getting Request Type Value
  function handleReqTypeChange(e) {
    setSelectedReqType(e.target.value)
    setIsSubCatSelected(false);
    setCategory("");
    setSubCatName("");
  }

  //Getting sub-category from category
  function handleCategoryChange(e) {
    setCategory(e.target.value);
    setSubDisabled(false);
    setIsSubCatSelected(false);
    setSelectedCat(e.target.value);
    setSelectedSubCat('')
    //setCategory(getCategory) 
  }
  // useEffect(() => { console.log(getCategory, "wohoo") }, [getCategory])

  function handleSubCategoryChange(e) {
    setSubCatName(e.target.value);
    setIsSubCatSelected(true);
    setSelectedSubCat(e.target.value)
  }

  function handleStatusChange(e) {

    if (getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.assignedto == null || getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.assignedto == 'string') {
      toast.error('Please assign to Technician!');
      navigate('../requests');
    }
    else {
      // console.log(e.target.value, 'in the elseeeeeeeeeeee');
      setSelectedStatus(e.target.value)
      setStatusflag(true);
    }
  }


  function getDocumentUploadDetails(file) {
    setDocumentcheck(true)
    // console.log('new file dddddddd', file);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("fileName", file.name);
    formData.append("containerName", "helpdeskfiles");

    apiClient
      .post(
        BaseURL + "/document/v1/Blob/upload_document",
        formData,
        {
          headers: {

            AuthKey: authKey,

          },
        }
      )
      .then((response) => {
        response?.data?.isSuccess === true ? toast.success(response?.data?.message) : toast.error(response?.data?.message);
        // response?.data?.isSuccess === true && 
        if (response?.data?.isSuccess === true) {
          const blobResponse = response?.data?.blobResponse
          const tempArr = {
            "documentName": blobResponse.fileName,
            "documentBlobName": blobResponse.blobFileName,
            "ticketOrEmail": ticketNumber,
            "isActive": 1,
            "documentContainerName": 'helpdeskfiles',
          };
          //setSelectedFiles(tempArr);
          setSelectedFiles((prevState) => ([...prevState, tempArr]));
          /// it is to store the previous state
        }

      })
      .catch(function (error) {
        console.log(error);
        toast.error(error.message);
        //   loaderService.hideLoader();
      });
  }
  //console.log('new selected222222 filesffffffffff', selectedFiles);
  //console.log('new selected222222 111111111filesffffffffff',selectedFiles[0].documentBlobName);
  //   ////////////////////////////////////////////

  function handleDocumentChange(e) {
    // console.log(e,'trrrrrrrrrrrrr')
    const choosenFiles = Array.prototype.slice.call(e.target.files)
    let total = 0;
    let pattern = /.*\..*\..*/g;
    choosenFiles.map((file) => {
      total = total + file.size
    })

    if (total > 5000000) {
      toast.error('File size should less than 5MB')
      return false;
      //setErrorMessage({ ...errorMessage, fileUploadError: 'One of the selected file size is more than 5MB, select the files which size less than 5MB' });
    }
    else if (choosenFiles.some(file => pattern.test(file.name.toLowerCase()))) {
      toast.error("Double extension file detected pls select proper file")
      return false;
    }
    else if (choosenFiles.some(file => fileNameValidation(file.name))) {
      toast.error(FILE_NAME_VALIDATION_ERROR)
      return false;
    }
    else if (choosenFiles.every(file => file.type == "image/png" || file.type == "image/jpg"
      || file.type == "image/jpeg" || file.type == "application/pdf")) {
      //   setSelectedFiles(e.target.files);
      //setErrorMessage({ ...errorMessage, fileUploadError: '' });
      choosenFiles.map((file) => {
        getDocumentUploadDetails(file)
      })
    }
    else {
      //  setErrorMessage({ ...errorMessage, fileUploadError: 'Please select the file type jpg,pdf,jpeg ' });
      toast.error('Please select the file type jpg, pdf, jpeg')
      return false;
    }
  };



  const downloadDocument = (file, type) => {

    return fetch(BaseURL + '/document/v1/Blob/download_document'
      ,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          AuthKey: authKey,
        },
        body: JSON.stringify({
          "fileName": file.documentBlobName,
          "containerName": "helpdeskfiles",
          "file": ""
        })
      })
      .then((response) => response.blob()
      )
      .then((blob) => {
        const fileName = file?.documentName
        const splittedName = fileName.split('.')
        const fileExtension = splittedName[splittedName.length - 1];
        let fileType;
        switch (fileExtension) {
          case 'pdf':
            fileType = 'application/pdf';
            break;
          case 'png':
            fileType = 'image/png';
            break;
          case 'jpg':
            fileType = 'image/jpeg';
            break;
          case 'jpeg':
            fileType = 'image/jpeg';
            break;
          default:
            fileType = 'application/octet-stream';
        }
        const url = window.URL.createObjectURL(new Blob([blob], { type: fileType }));
        const newWindow = window.open(url, '_blank');
        newWindow.focus();
        // loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        // loaderService.hideLoader()
      });
  }


  function handleDelete(file, index) {
    // console.log(file, 'into the file deleteuuuuuuuuu');
    // console.log('eeeeeeeeeeeeeeeeeeeeeeeeee');

    apiClient
      .post(
        BaseURL + "/document/v1/Blob/delete_document",
        {
          "fileName": file.documentBlobName,
          "containerName": "helpdeskfiles",
        },
        {
          headers: {

            "Authorization": "Bearer " + getLocalStorageItem('id_token')
          },
        }
      )
      .then((response) => {

        response?.data?.isSuccess === true ? toast.success(response?.data?.message) : toast.error(response?.data?.message);
        // response?.data?.isSuccess === true && 

        if (response?.data?.isSuccess === true && file.id != null) {


          let onSaveForm = {
            "helpdeskGrievanceEnquiryEntityPojo": {
              "ticketNumber": ticketNumber,
              "updatedBy": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.updtdBy,
              "urn": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.urn,
              "assignedto": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.assignedto,
              "mobile": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.mobile,
              "firstName": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.firstName,
              "middleName": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.middleName,
              "lastName": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.lastName,
              // "dueDate": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.dueDate,
              // "crtdOn": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.crtdOn,
              "requestType": selectedReqType,
              "category": selectedCat,
              "subCategory": selectedSubCat,
              "status": selectedStatus,
              "priority": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.priority,
              "sla": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.sla,
              "description": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.grievanceDescription,
              "extFlag": getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.extFlag
            },
            helpdeskDocumentMasterEntity:

              [{
                "id": file.id,
                "isActive": 0,
                "documentContainerName": 'helpdeskfiles',
                "ticketOrEmail": ticketNumber
              }]

          }
          apiClient.post(
            BaseURL + '/grievanceandhelpdesk/v1/helpdesk/updateTicketsubmit',
            onSaveForm,
            {
              headers: {
                "Authorization": "Bearer " + getLocalStorageItem('id_token')
              },
            }).then((response) => {
              //  console.log('rrrrrrrrrrreeeeee', response);
              //   getTicketDetails(ticketNumber)
              const newArr = [...selectedFiles];
              newArr.splice(index, 1);
              setSelectedFiles(newArr)
              setsubmitForm(response.data)

            }).catch((error) => {
              console.log(error);
            })

        }
        else {
          // getTicketDetails(ticketNumber)
          const newArr = [...selectedFiles];
          newArr.splice(index, 1);
          setSelectedFiles(newArr)
        }

      })

      .catch(function (error) {
        console.log(error);
        toast.error(error.message);
        //   loaderService.hideLoader();
      });

  }



  useEffect(() => {
    //getTicketList();
    setGetTicket(data);
    fetchRequest();
    fetchCatagory();
    getTicketDetails(ticketNumber);
    fetchStatusRequest()
  }, [])

  const categoryList = (localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser || getTicketPrefix() === 'EXT') ? respData?.External_category : respData?.Helpdesk_category

  return (
    <>
      <Helmet>
        <title> Grievance Resolution | ABEPL </title>
      </Helmet>

      <Container maxWidth="xxl">
        <Typography variant="h4" sx={{ mb: 2 }}>
          <Fab component={RouterLink} to='../requests' size="small" aria-label="back">
            <KeyboardArrowLeftRounded />
          </Fab> {t('helpdesk.grievanceResolution')}
        </Typography>
        <Card>
          <Stack spacing={2} sx={{ m: 2 }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item lg={3} xs={12}>
                    <Card sx={{ p: 1, width: '100%', }}>
                      <Stack direction="row" spacing={1}>
                        <Typography variant='subtitle2'>{t('helpdesk.ticketNumber')}</Typography>
                        <Divider orientation="vertical" flexItem />
                        <Typography variant='subtitle2'>{ticketNumber}</Typography>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item lg={5} xs={12}>
                    <Card sx={{ p: 1, width: '100%', }}>
                      <Stack direction="row" spacing={2}>
                        <Typography variant='subtitle2'>{t('helpdesk.userId')}</Typography>
                        <Divider orientation="vertical" flexItem />
                        <Typography variant='subtitle2'>{getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.urn}</Typography>
                      </Stack>
                    </Card>
                  </Grid>
                  <Grid item lg={4} xs={12}>
                    <Card sx={{ p: 1, width: '100%', }}>
                      <Stack direction="row" spacing={2}>
                        <Typography variant='subtitle2'>{t('helpdesk.contactNo')}</Typography>
                        <Divider orientation="vertical" flexItem />
                        <Typography variant='subtitle2'>{getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.requesterContactNo}</Typography>
                      </Stack>
                    </Card>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={12}>
                <Card>
                  <Scrollbar>
                    <Table aria-label="simple table" size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">Requester Name</TableCell>
                          <TableCell align="left">Mobile Number</TableCell>
                          {/* <TableCell align="left">User ID</TableCell> */}
                          <TableCell align="left">Technician</TableCell>

                          <TableCell align="left">Due by date</TableCell>
                          <TableCell align="left">Created Date</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {/* {getTicket.filter(ticketID => ticketID.ticketNumber == ticketNumber).map((filteredName) => { */}
                        {/* {getTktDetail?.helpdeskGrievanceEnquiryEntity?.map((getTktDetail?.helpdeskGrievanceEnquiryEntity?)=> { */}
                        {/* return ( */}
                        <Fragment>
                          <TableRow>
                            <TableCell align="left">{getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.firstName} {getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.middleName} {getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.lastName}</TableCell>
                            <TableCell align="left">{getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.mobile}</TableCell>

                            <TableCell align="left"> {getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.assignedto} </TableCell>

                            <TableCell align="left">
                              {/* {new Date().toLocaleDateString()} */}
                              {getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.dueDateStr || "--"}
                            </TableCell>
                            <TableCell align="left">
                              {/* {new Date().toLocaleDateString()} */}
                              {getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.createdDateStr || "--"}
                            </TableCell>
                          </TableRow>
                        </Fragment>
                        {/* )
                        })} */}

                      </TableBody>
                    </Table>

                  </Scrollbar>
                </Card>
              </Grid>
            </Grid>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ pt: 1 }}>
              <FormControl fullWidth size="small" disabled={!isEdit}>
                <InputLabel id="select-requestType-label">{t('helpdesk.requestType')}</InputLabel>
                <Select
                  labelId="select-requestType-label"
                  id="select-requestType"
                  label={t('helpdesk.requestType')}
                  // defaultValue={selectedReqType}
                  value={selectedReqType}
                  onChange={handleReqTypeChange}
                >
                  <MenuItem value="">
                    <em>{t('helpdesk.select')}</em>
                  </MenuItem>

                  {
                    requesttype.map(function (object, i) {
                      return <MenuItem value={object.value} key={object.value}>{object.value || "Request Type"}</MenuItem>
                    })
                  }
                </Select>
              </FormControl>
              <FormControl fullWidth size="small" disabled={!isEdit}>
                <InputLabel id="select-category-label">{t('helpdesk.category')}</InputLabel>
                <Select
                  labelId="select-category-label"
                  id="select-category"
                  label="category"
                  // defaultValue={selectedCat}
                  value={selectedCat}
                  onChange={handleCategoryChange}
                >
                  <MenuItem value="">
                    <em>{t('helpdesk.select')}</em>
                  </MenuItem>
                  {categoryList?.map(function (categoryList, i) {
                    return <MenuItem key={categoryList} value={categoryList}>{categoryList}</MenuItem>
                  })}
                </Select>
              </FormControl>
              <FormControl fullWidth size="small" disabled={!isEdit}>
                <InputLabel id="select-subCategory-label">{t('helpdesk.subCategory')}</InputLabel>
                <Select
                  labelId="select-subCategory-label"
                  id="select-subCategory"
                  label="Sub-Category"
                  // defaultValue={selectedSubCat}
                  value={selectedSubCat}
                  onChange={handleSubCategoryChange}
                >
                  <MenuItem value="">
                    <em>{t('helpdesk.select')}</em>
                  </MenuItem>
                  {respData && respData[`${selectedCat}`]?.map(function (subcat, i) {
                    return <MenuItem key={subcat} value={subcat}>
                      {subcat}</MenuItem>
                  })}
                </Select>
              </FormControl>
            </Stack>

            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ pt: 1 }}>
              <FormControl fullWidth size="small" disabled={!isEdit}>
                <InputLabel id="select-status-label">{t('helpdesk.status')}</InputLabel>
                <Select
                  labelId="select-status-label"
                  id="select-status"
                  label="Status"
                  // defaultValue={selectedStatus}
                  value={selectedStatus}
                  onChange={handleStatusChange}
                >
                  <MenuItem value="">
                    <em>Select</em>
                  </MenuItem>
                  {/* <MenuItem value={1}>Open</MenuItem>
                  <MenuItem value={2}>Work in progress</MenuItem>
                  <MenuItem value={3}>Resolved</MenuItem>
                  <MenuItem value={9}>Awaiting End User Response</MenuItem> */}
                  {
                    statusType.map(function (object, i) {
                      return <MenuItem value={object.value} key={object.value}>{object.value}</MenuItem>
                    })
                  }
                </Select>
              </FormControl>
              <FormControl fullWidth size="small" disabled>
                <InputLabel id="select-priority-label">{t('helpdesk.priority')}</InputLabel>
                <Select
                  labelId="select-priority-label"
                  id="select-priority"
                  label={t('helpdesk.priority')}
                  // inputProps={{ readOnly: true }}
                  // defaultValue={selectedPriority}
                  value={selectedPriority}
                // onChange={handlePriorityChange}
                >
                  <MenuItem value={selectedPriority}>
                    <em>{selectedPriority}</em>
                  </MenuItem>
                  {/* <MenuItem value={1}>P1</MenuItem>
                  <MenuItem value={2}>P2</MenuItem>
                  <MenuItem value={3}>P3</MenuItem>
                  <MenuItem value={4}>P4</MenuItem> */}
                </Select>
              </FormControl>
              <FormControl fullWidth size="small">
                <TextField disabled
                  sx={{ mt: 0 }}
                  autoComplete="off"
                  variant="outlined" label={t('helpdesk.sla')}
                  id="input-sla"
                  // defaultValue={selectedSLA}
                  value={selectedSLA}
                  size="small"
                />
              </FormControl>
            </Stack>

            <Stack sx={{ pt: 1 }}>
              <Card>
                <CardContent>
                  {/* {console.log("getTicket", )}
                  {getTicket.filter(ticketID => ticketID.ticketNumber == ticketNumber).map((item) => {
                    return (
                      <Typography variant='body2' key={item.ticketNumber}> */}
                  <Typography variant='subtitle2' component={'span'}>{t('helpdesk.description')}: </Typography>{getTktDetail?.helpdeskGrievanceEnquiryEntity?.[0]?.grievanceDescription ?? t('helpdesk.noDescriptionAvailable')}
                  {/* </Typography>
                    );
                  })} */}
                </CardContent>
              </Card>
            </Stack>

            <Box sx={{ paddingLeft: '3%' }} >

              {/* <Box component="outlined" sx={{  borderRadius: '16px', border: '2px dashed ', borderColor: 'secondary.main' }}> */}
              <Grid xs={12} lg={12}>

                {docedit && (
                  <>
                    <p>{t('helpdesk.attachments')}</p>
                    <Card style={{ backgroundColor: '#E7EBE8', width: '25%' }}>

                      <Stack direction="column"
                        justifyContent="center"
                        alignItems="center">

                        <IconButton disabled color="secondary" >
                          <CloudUploadIcon color="warning"
                            fontSize="large"
                          />
                        </IconButton>
                        <Button variant="contained" component="label" disabled={!docedit} >{t('helpdesk.browse')}
                          <input id='fileUpload' name='fileUpload' type="file" multiple

                            onChange={(e) => { handleDocumentChange(e); e.target.value = null }}

                            //  accept='application/pdf, image/png'
                            //  disabled={fileLimit}
                            placeholder="Upload"
                            style={{ display: "none" }}
                          />

                        </Button>
                        <label style={{ fontSize: '10px' }}>{t('helpdesk.supportedFile')}</label>
                        {/* </Box> */}
                      </Stack>
                    </Card>
                  </>
                )}
                <Grid item xs={12} sm={6} md={6}>
                  {selectedFiles.map((file, index) => (
                    <Stack direction="row">
                      📁
                      &nbsp;
                      <Typography color="neutral" > {file?.documentName}
                        &nbsp;
                        &nbsp;

                        <RemoveRedEyeIcon color="primary" onClick={() => downloadDocument(file, "Create")} variant="outlined" size="sm" />

                      </Typography>
                      {isEdit && <DeleteIcon onClick={() => handleDelete(file, index)} />}
                      {/* <DeleteIcon color="error" fontSize="small" sx={{ mt: 0.5 }}   /> */}
                    </Stack>
                  ))
                  }
                </Grid>

              </Grid>


            </Box>

            <Box sx={{ mt: 1 }} display='flex' alignItems="center" justifyContent="flex-end">
              <Button onClick={handleEdit} startIcon={<EditIcon />} disabled={isEdit} sx={{ minWidth: 120 }} variant="outlined">{t('helpdesk.edit')}</Button>
              <Button onClick={handleSave} startIcon={<SaveIcon />} disabled={!docedit} sx={{ minWidth: 120, ml: 1 }} variant="contained">{t('helpdesk.save')}</Button>
            </Box>
            <Grid container>
              <Grid item xs={12}>
                <Card>
                  <CardContent>
                    <Typography sx={{ fontSize: 14 }} color="text.secondary">
                      {t('helpdesk.worklogs')}
                      <Button justifyContent="flex-end" sx={{ ml: 2 }} variant="text" startIcon={<AddIcon />} onClick={handleLogModalOpen}>
                        {t('helpdesk.addComment')}
                      </Button>
                    </Typography>
                  </CardContent>
                  {/* <Scrollbar> */}
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell />
                        <TableCell align="left">{t('helpdesk.comment')}</TableCell>
                        <TableCell align="left">{t('helpdesk.changedBy')}</TableCell>
                        <TableCell align="left">{t('helpdesk.changedTimestamp')}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(rowsPerPage > 0
                        ? comment.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        : comment
                      ).map((row, idx) => (
                        <WorklogListRow key={row.id} row={row} />
                      ))}
                      {emptyRows > 0 && (
                        <TableRow style={{ height: 35 * emptyRows }}>
                          <TableCell colSpan={4} />
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                  {/* </Scrollbar> */}
                  {comment.length > 0 && (
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25]}
                      component="div"
                      count={comment.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      showFirstButton showLastButton
                    />)}
                </Card>
              </Grid>
            </Grid>
          </Stack>
        </Card>
      </Container>
      <ConfirmationPopover onOpen={logConfirmModalOpen} onConfirm={onConfirmSave} onClose={handleConfirmLogModalClose} action="Submit" />
      <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
        {/* <DialogTitle>New Worklog</DialogTitle> */}
        <DialogContent>
          {/* <DialogContentText></DialogContentText> */}
          <TextField
            autoFocus
            // margin="dense"
            id="newWorklog"
            label={t('helpdesk.newWorklog')}
            type="text"
            fullWidth multiline rows={4}
            variant="standard"
            value={addComment}


            onChange={(e) => setAddComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}

          />
          <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '2%' }}>
            <Badge bg={`${addComment.length > characterLimit ? 'danger' : 'primary'}`}>{addComment.length}/{characterLimit}</Badge>
          </div>

        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleLogModalClose}>{t('reg.cancel')}</Button>
          <Button variant="contained" disabled={isUpdatingRef.current} onClick={updateWorklog}>{t('helpdesk.save')}</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default GrievanceResolution